import { css } from '@emotion/react';
import { theme } from '@omnigenbiodata/ui';

export const useStyles = () => {
  return {
    appBar: {
      borderTopWidth: 8,
      borderTopStyle: 'solid',
      borderTopColor: theme.palette.primary.main,
    },
    appBarHamburger: { marginRight: theme.spacing(1) },
    content: css`
      flex-grow: 1;
      align-content: flex-start;
    `,
    logoutBtn: css`
      margin-right: 10px;
    `,
    root: css`
      background: linear-gradient(180deg, ${theme.palette.grey[200]} 0%, ${theme.palette.background.paper} 100%);
      min-height: 100vh;

      ${theme.breakpoints.up('md')} {
        padding: ${theme.spacing(2)};
      },
    `,
    paper: css`
      min-height: calc(100vh - ${theme.spacing(2)});
      padding-top: ${theme.spacing(2)};
      padding-bottom: ${theme.spacing(2)};
      padding-left: ${theme.spacing(2)};
      padding-right: ${theme.spacing(2)};
      display: flex;
      flex-direction: column;
    `,
    paperShaded: css`
      background: linear-gradient(180deg, ${theme.palette.grey[200]} 0%, ${theme.palette.background.paper} 100%);
    `,
  };
};
